<template>
  <div>
    <page-header :title="$t('bill.monthly_bill_detail')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv">
      <div slot="res-status-tab">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <resource-list :id="listId" :cloud-env="cloudEnv" :billShared="billShared" :projectShared="projectShared" @updateBillShared="updateBillShared" @updateProjectShared="updateProjectShared" />
    </page-body>
  </div>
</template>

<script>
import currencyMixin from '@Bill/mixins/currency'
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import { getCloudEnvOptions } from '@/utils/common/hypervisor'
import ResourceList from './components/List'

export default {
  name: 'ResourceIndex',
  components: {
    ResourceList,
    BillConfig,
  },
  mixins: [currencyMixin, shareMixin],
  data () {
    return {
      listId: 'BillAssociateList',
      cloudEnvOptions: getCloudEnvOptions('brands'),
      cloudEnv: '',
    }
  },
  methods: {
  },
}
</script>
